$(document).on("turbolinks:load ready", function () {
  if ($(".js-select-dynamic-search").is("*")) {
    document
      .getElementsByClassName("js-select-dynamic-search")
      .forEach(createSelectpickerSearch);
  }
});

function createSelectpickerSearch(element) {
  var search_url = $(element).data("search-url");
  var new_object_option = $(element).data("new");

  $(element)
    .selectpicker({
      actionsBox: true,
      liveSearch: true,
    })
    .ajaxSelectPicker({
      ajax: {
        url: search_url + "?new_object=" + new_object_option,
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "X-CSRF-Token",
            localStorage.getItem("bp-x-csrf-token")
          );
        },
        data: function () {
          var params = {
            q: "{{{q}}}",
          };

          return params;
        },
      },
      clearOnEmpty: false,
      emptyRequest: true,
      cache: false,
      preserveSelected: true,
    });
}

var MIN_MENU_INNER_HEIGHT = 80;

var ARROW_OR_TAB_KEYS = [9, 38, 40];

$(document).on('shown.bs.select', function (event) {
  var picker = $(event.target).data('selectpicker');

  if(!picker || !picker.$searchbox || !picker.$searchbox.is('*')){
    return;
  }

  if(picker.$searchbox.data('bp-empty-search-guard')){
    return;
  }

  picker.$searchbox.data('bp-empty-search-guard', true);

  picker.$searchbox.on('keydown', function (keyEvent) {
    if(ARROW_OR_TAB_KEYS.indexOf(keyEvent.which) === -1){
      return;
    }

    var view = picker.selectpicker && picker.selectpicker.view;
    var canHighlight = view && view.canHighlight;

    if(canHighlight && canHighlight.indexOf(true) !== -1){
      return;
    }

    keyEvent.stopPropagation();
  });
});

onmount(".js-selectpicker-add-more", function () {
  document
    .getElementsByClassName("js-selectpicker-add-more")
    .forEach(createAddMoreSelectpicker);
})

function createAddMoreSelectpicker(element) {
  if($(element).hasClass('js-has-init')){
    return;
  }

  $(element).addClass('js-has-init')

  var $select = $(element);

  $select.selectpicker({
    actionsBox: false,
    liveSearch: true
  });

  var picker = $select.data('selectpicker');

  if(!picker){
    return;
  }

  var $addNew = $("<div class='js-selectpicker-new-option'><span class='btn btn-outline-primary btn-block'>+ Add <span class='new-option'></span></span></div>").hide();

  picker.$menu.append($addNew);

  function searchTerm() {
    return $.trim(picker.$searchbox.val() || '');
  }

  function selectableMatch(term) {
    var lowerTerm = term.toLowerCase();

    return $select.find('option').filter(function () {
      return this.style.display !== 'none' && $.trim(this.text).toLowerCase() === lowerTerm;
    }).length > 0;
  }

  function refreshAddNew() {
    var term = searchTerm();

    if(term.length === 0 || selectableMatch(term)){
      $addNew.hide();
      return;
    }

    $addNew.find('.new-option').text(term);
    $addNew.show();

    fitAddNew();
  }

  // The menu is capped to the space below the select and clips whatever
  // overflows, so shrink the scrollable option list to make room for the
  // add row rather than letting it get cut off.
  function fitAddNew() {
    var menuMaxHeight = parseFloat(picker.$menu.css('max-height'));
    var innerMaxHeight = parseFloat(picker.$menuInner.css('max-height'));

    if(!menuMaxHeight || !innerMaxHeight){
      return;
    }

    var overflow = picker.$menu[0].scrollHeight - menuMaxHeight;

    if(overflow <= 0){
      return;
    }

    picker.$menuInner.css('max-height', Math.max(innerMaxHeight - overflow, MIN_MENU_INNER_HEIGHT) + 'px');

    // Too little room below the select to fit even a minimal list: let the menu
    // grow past it rather than hiding the add row.
    var remaining = picker.$menu[0].scrollHeight - menuMaxHeight;

    if(remaining > 0){
      picker.$menu.css('max-height', (menuMaxHeight + remaining) + 'px');
    }
  }

  function currentOptionName() {
    return $select
      .closest('.js-variant-option-table-row')
      .find('select[name*="[name]"]')
      .val();
  }

  picker.$searchbox.on('input propertychange', refreshAddNew);
  $select.on('shown.bs.select', refreshAddNew);
  $select.on('hidden.bs.select', function () { $addNew.hide(); });

  function addValues(values) {
    var optionName = currentOptionName();

    values.forEach(function (value) {
      var $existing = $select.find('option').filter(function () {
        return this.style.display !== 'none' && $.trim(this.text).toLowerCase() === value.toLowerCase();
      });

      if($existing.is('*')){
        $existing.prop('selected', true);
        return;
      }

      var $option = $('<option>', { value: value, text: value, selected: 'selected' });

      if($select.hasClass('js-option-values-select')){
        $option.attr('data-option-name', optionName);
      }

      $select.append($option);
    });

    $select.selectpicker('refresh');
    $select[0].dispatchEvent(new Event("change"));

    picker.$searchbox.val('').trigger('input');
  }

  $addNew.on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    var name = $.trim($addNew.find('.new-option').text());

    if(name.length === 0){
      return;
    }

    var splitValues = splitOnCommas(name);

    if($select.prop('multiple') && splitValues.length > 1){
      $select.selectpicker('toggle');

      confirmSplitOptions(name, splitValues, function (values) {
        addValues(values);
      });

      return;
    }

    addValues([name]);

    if(!$select.prop('multiple')){
      $select.selectpicker('toggle');
    }
  });
}

function splitOnCommas(value) {
  var seen = {};

  return value
    .split(',')
    .map(function (part) { return $.trim(part); })
    .filter(function (part) {
      var key = part.toLowerCase();

      if(part.length === 0 || seen[key]){
        return false;
      }

      seen[key] = true;
      return true;
    });
}

function confirmSplitOptions(singleValue, splitValues, callback) {
  var $modal = $('#variant-split-options-modal');

  if(!$modal.is('*')){
    callback([singleValue]);
    return;
  }

  var chipClass = 'js-split-preview-chip d-inline-block border rounded px-2 py-1 mr-1 mb-1';

  $modal.find('.js-split-preview-individual').empty().append(
    splitValues.map(function (value) {
      return $('<span>', { class: chipClass, text: value });
    })
  );

  $modal.find('.js-split-preview-single').empty().append(
    $('<span>', { class: chipClass, text: singleValue })
  );

  $modal.find('.js-split-into-individual').off('click.splitOptions').on('click.splitOptions', function () {
    $modal.modal('hide');
    callback(splitValues);
  });

  $modal.find('.js-split-keep-single').off('click.splitOptions').on('click.splitOptions', function () {
    $modal.modal('hide');
    callback([singleValue]);
  });

  $modal.modal('show');
}